import { Link } from "react-router-dom";
import { comics, newIds } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import SectionHeader from "@/components/feature/SectionHeader";

function NewArrivals() {
  const list = comics.filter((c) => newIds.includes(c.id));

  return (
    <section className="border-t border-background-800 bg-background-900/30 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeader
            eyebrow="Fresh Arrivals"
            title="新作上架 · 抢先体验"
            desc="刚刚登陆土豪漫画网的惊喜新作，钻石品质诚意呈现，第一时间开启你的专属阅读。"
          />
          <Link
            to="/category"
            className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 hover:text-primary-200 transition cursor-pointer"
          >
            更多新作
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4 md:gap-6">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default NewArrivals;